import {createContext} from 'react';
export interface ErpAlertContextModel {
  add: (type: 'success' | 'danger', message: string) => void | null;
}

export const ErpAlertContext = createContext<{ context: ErpAlertContextModel | null }>({
  context: null,
});
